/**
 * Remove da peça de e-mail os blocos que só fazem sentido numa caixa de entrada
 * (CENTRAL-04.2, emendada na Fase 5).
 *
 * O template é o mesmo nos dois canais — é ele que o produtor manda por e-mail e
 * é ele que a central mostra. Mas quatro dos oito blocos mentem quando lidos
 * dentro do app: o preheader é texto de prévia de caixa de entrada; o "copie e
 * cole este link no navegador" fala com quem não está num navegador; o rodapé
 * afirma "não é necessário respondê-lo" e "você recebeu este e-mail" para quem
 * não recebeu e-mail nenhum; e o botão aponta para uma URL absoluta que
 * recarregaria a SPA inteira, já que HTML injetado nunca vira `<Link>`.
 *
 * A escolha de QUAIS blocos somem não mora aqui — mora no template, no atributo
 * `data-inapp="hide"`. A alternativa era casar por texto conhecido ou por
 * posição, e as duas quebram caladas: alguém reescreve o rodapé pelo Studio, o
 * casamento para de valer, e o "não é necessário respondê-lo" volta ao app sem
 * erro em lugar nenhum. Cliente de e-mail ignora atributo desconhecido, então o
 * marcador não custa um pixel do lado do e-mail.
 *
 * Roda DEPOIS do `sanitizeHtml`, nunca antes. A poda é cosmética e a barreira de
 * segurança não deve depender dela: se o marcador sumir ou não casar nada, o
 * pior caso é rodapé feio — jamais HTML não saneado. `data-*` sobrevive ao
 * DOMPurify por padrão, o que está provado em `sanitizeHtml.test.ts`.
 *
 * `DOMParser` com `text/html` produz documento inerte: não executa script, não
 * carrega imagem, não roda handler.
 */
const MARCADOR = '[data-inapp="hide"]';

export function pruneEmailChrome(html: string): string {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  doc.body.querySelectorAll(MARCADOR).forEach(node => node.remove());

  return doc.body.innerHTML;
}
